import { FC, Fragment } from 'react';

import { Container } from './styles';

interface HeaderProps {
  title?: string;
  subtitle: string;
  extraSubtitle?: string;
}

export const Header: FC<HeaderProps> = ({ title, subtitle, extraSubtitle }) => {
  return (
    <Container>
      {!!title && <h2>{title}</h2>}

      <p>
        {subtitle.split('\n').map((line) => (
          <Fragment key={line}>
            {line}
            <br />
          </Fragment>
        ))}
      </p>
      {extraSubtitle && <small>{extraSubtitle}</small>}
    </Container>
  );
};
